<!-- 
<template>
  <div class="container">
    <header class="jumbotron">
      <h3>{{content}}</h3>
    </header>
  </div>
</template>

<script>
import UserService from '../services/user.service';

export default {
  name: 'Home',
  data() {
    return {
      content: ''
    };
  },
  mounted() {
    UserService.getPublicContent().then(
      response => {
        this.content = response.data;
      },
      error => {
        this.content =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
};
</script>
-->

<template>
  <div class="landing-container">
    <LandingNav />
    <LandingContent />
  </div>
</template>

<script>

import LandingContent from "../components/Landing/LandingContent"
import LandingNav from "../components/Common/LandingNav"

export default {
    
  components: { LandingContent, LandingNav },

}
</script>

<style lang="scss">
@import "../sass/main.scss";

.landing-container {
    min-height: 100vh;
    background: #fff;
    margin-top: -100px;
}

</style>